import React from 'react'
import PropTypes from 'prop-types'
import Table from 'components/Table'
import { makeSitesColumns, makeSitesRows } from '../modalTable'
import { SitesTableWrapper } from './style'
import { useNavigate } from 'react-router-dom'
import { buildAboutUrl, editOnly } from 'routing/constants'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'

const AssessmentModal = ({ sites }) => {
  const history = useNavigate()

  const columns = makeSitesColumns()
  const rows = makeSitesRows(sites)

  const rowOnClick = (siteId, historyId, siteStatusId) => {
    const editOnlySite = siteStatusId === SITE_STATUS_EDIT_ONLY_ID || siteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null
    history(buildAboutUrl(siteId, historyId, editOnlySite))
  }

  return (
      <SitesTableWrapper>
        <Table
          columns={columns}
          rows={rows}
          noResultMessage='noReassessmentHistory'
          dataTest='sites-list'
          rowOnClick={rowOnClick}
        />
      </SitesTableWrapper>
  )
}

AssessmentModal.propTypes = {
  sites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      createdAt: PropTypes.string,
      SiteStatusId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      historyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      sitehistoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      User: PropTypes.shape({
        lastName: PropTypes.string,
        firstName: PropTypes.string,
      }),
    })
  ).isRequired,
}

export default AssessmentModal
